import React, { useEffect, useState, createElement } from 'react';
import { X as XIcon } from 'lucide-react';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Check if we've shown the popup in this session
    const hasShownPopup = sessionStorage.getItem('exitPopupShown');
    if (hasShownPopup) return;
    // Function to detect when mouse leaves the viewport at the top
    const handleMouseLeave = (e: MouseEvent) => {
      // Only trigger when mouse moves to the top of the page
      if (e.clientY <= 5 && !isVisible) {
        setIsVisible(true);
        // Mark that we've shown the popup
        sessionStorage.setItem('exitPopupShown', 'true');
      }
    };
    // Add the event listener
    document.addEventListener('mouseleave', handleMouseLeave);
    // Cleanup
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [isVisible]);
  const handleClose = () => {
    setIsVisible(false);
  };
  if (!isVisible) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-84">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative animate-fade-in-up" data-id="element-85">
        <button onClick={handleClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" aria-label="Stäng popup" data-id="element-86">
          <XIcon size={24} data-id="element-87" />
        </button>
        <div className="text-center mb-6" data-id="element-88">
          <h2 className="text-2xl font-bold text-amber-800 mb-2" data-id="element-89">
            Vänta lite!
          </h2>
          <p className="text-lg text-gray-700 mb-4" data-id="element-90">
            Innan du går - vi vill berätta om vårt specialerbjudande som bara är
            tillgängligt just nu.
          </p>
          <div className="bg-amber-100 p-4 rounded-lg mb-4" data-id="element-91">
            <p className="font-bold text-amber-800 text-xl" data-id="element-92">
              SPECIALERBJUDANDE
            </p>
            <p className="text-amber-700" data-id="element-93">
              50% rabatt på ditt 30-dagars testpaket
            </p>
            <p className="text-sm text-amber-600 mt-1" data-id="element-94">
              Endast för nya kunder!
            </p>
          </div>
          <button onClick={() => {
          // Scroll to special offer section
          document.querySelector('.special-offer')?.scrollIntoView({
            behavior: 'smooth'
          });
          handleClose();
        }} className="bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-6 rounded-lg w-full transition-colors" data-id="element-95">
            Ja tack, visa mig erbjudandet!
          </button>
          <button onClick={handleClose} className="mt-3 text-gray-600 hover:text-gray-800 text-sm" data-id="element-96">
            Nej tack, jag är inte intresserad just nu
          </button>
        </div>
      </div>
    </div>;
}
// Add animation for the popup
const style = document.createElement('style');
style.textContent = `
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .animate-fade-in-up {
    animation: fadeInUp 0.3s ease-out forwards;
  }
`;
document.head.appendChild(style);